import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { DialogContent, DialogTitle } from "components/common/DialogApi";
import {
  Box,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import securityActions from "../actions";
import useStyles from "../styles";
import Transition from "components/common/Transition";

const ChangePasswordStrength = () => {
  const classes = useStyles();
  const { isPwdStrengthDialogOpen, security } = useSelector(
    (state) => state.security
  );
  const { setPwdStrengthDialogOpen, setPasswordPolicy, setSettings } =
    securityActions();

  const handleChange = (event) => {
    setPasswordPolicy(event.target.value);
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Dialog
      fullScreen={!matches}
      disableBackdropClick
      TransitionComponent={Transition}
      open={isPwdStrengthDialogOpen}
      maxWidth="sm"
      aria-labelledby="pwd-strength-change"
    >
      <DialogTitle
        id="pwd-strength-change"
        onClose={() => setPwdStrengthDialogOpen(false)}
      >
        <Grid container justify="center">
          <Typography variant="h5">Change password strength</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Box className={classes.dialogContent}>
          <Typography variant="body2">
            Change to passwords strength will only affect newly created accounts
          </Typography>
          <Typography className={classes.content} variant="subtitle2">
            Password strength
          </Typography>
          <FormControl className={classes.formControl}>
            <RadioGroup
              value={security.password["policy_name"]}
              onChange={handleChange}
            >
              <FormControlLabel
                variant="subtitle2"
                value="simple"
                control={<Radio color="primary" />}
                label="Simple"
              />
              <FormHelperText>Simple At least 8 characters long</FormHelperText>
              <FormControlLabel
                variant="subtitle2"
                value="strong"
                control={<Radio color="primary" />}
                label="Strong"
              />
              <FormHelperText>
                Strong At least 8 characters long, must include characters of
                different types: Lowercase, uppercase, numbers and special
                characters
              </FormHelperText>
            </RadioGroup>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth={!matches}
          variant="outlined"
          color="secondary"
          onClick={() => setPwdStrengthDialogOpen(false)}
        >
          Cancel
        </Button>
        <Button
          fullWidth={!matches}
          variant="contained"
          color="primary"
          onClick={() => setSettings(() => setPwdStrengthDialogOpen(false))}
        >
          Save setting
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordStrength;
